<template>
  <div class="professionField">
    <div class="label">
      <span class="required">*</span>{{ label }}
    </div>
    <div class="value">
      <input v-model="ProfessionField" type="text" placeholder="输入您的职业" @input="handleInput" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ProfessionField",
  components: {},
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      ProfessionField: "",
    };
  },
  async mounted() {},
  methods: {
    handleInput(val) {
      this.ProfessionField = val.target.value;
      this.$emit("input", val.target.value);
    },
  },
  watch: {
    value(newVal) {
      this.ProfessionField = newVal;
    },
  },
};
</script>

<style scoped lang="scss">
.professionField {
  display: flex;
  align-items: center;
  padding: 12px 0px;
}
.label {
  font-size: 14px;
  color: #333333;
  width: 80px;
  .required{
    color: #FF0000;
  }
}
.value {
  flex: 1;
  display: flex;
  align-items: center;
  border-radius: 17px;
  height: 33px;
  background: #F8F8F8;
  padding-left: 16px;
  font-size: 14px;
  input {
    border: none;
    outline: none;
    background: transparent;
    &::placeholder {
      color: rgba(51,51,51,0.4);
    }
  }
}
</style>
